package com.essntl.features.country.domain.model

data class CountryModel(
    val id: String,
    val name: String,
    val createdAt: String,
) {
    fun getChangedFields(country: CountryModel) =
        CountryModel(
            id = id,
            createdAt = createdAt,
            name = if (name.lowercase().capitalize() != country.name.lowercase().capitalize()) country.name.lowercase().capitalize() else "",
        )

    val isEmpty
        get() = this.copy(id = "", createdAt = "") == empty

    companion object {
        val empty =
            CountryModel(
                id = "",
                name = "",
                createdAt = "",
            )
    }
}
